import { ENVS } from "@v2/shared/environment.config";
import { getFeatureFlagPayload } from "@v2/shared/lib/posthog";
import { TrelloIframeClientManager } from "@v2/shared/api/trello";

export function isUnderMaintenance() {
  const payload = getFeatureFlagPayload("is-under-maintenance");
  const result =
    payload &&
    !payload.exempted?.includes(
      TrelloIframeClientManager.getClient()?.getContext?.()?.member ?? ""
    ) &&
    payload.value;
  return result;
}

/** Feature flagging for mirrored capture
 * Non-production: always mirror.
 * Production: mirror only if either flag is enabled via PostHog client API.
 */
export function isMirroringEventsToPosthogEnabled(): boolean {
  if (!isTrackingInPosthogEnbaled()) return false;
  if (ENVS.environment === "production") return true;
  return true;
}

export function isRecordingSessionsToPosthogEnabled(): boolean {
  if (!isTrackingInPosthogEnbaled()) return false;
  if (ENVS.environment === "production") return true;
  return true;
}

export function isTrackingInSentryEnbaled(): boolean {
  if (ENVS.environment === "production") return true;
  return false;
}

// AIDEV-NOTE: For now I am not sure how to implement it, since posthog.opt_out_capturing() seem to be unstable at runtime.
// Hence, I will use add blocker when I do not want it to be captured
function isTrackingInPosthogEnbaled(): boolean {
  if (ENVS.environment === "production") return true;
  return false;
}